module.exports = __webpack_public_path__ + "img/scale_device.205e6237.png";